import Head from "next/head";
import { useState } from "react";
import Layout from "../components/layout";
import SEOMeta from "../components/SEOMeta";
import { getInnerPageContent } from "../lib/api";
import MailTemplate from "../components/MailTemplate";
import { render } from '@react-email/render';
import { SES } from '@aws-sdk/client-ses';

interface mailType {
  name: string;
  email: string;
  subject: string;
  message: string;
}

export default function Contact({ pageCont, SES_credentials }) {

  const ses = new SES({
    region: SES_credentials.region,
    credentials: {
      accessKeyId: SES_credentials.accessKeyId,
      secretAccessKey: SES_credentials.secretAccessKey,
    },
  });

  if (!pageCont) return <></>;

  const [formData, setFormData] = useState({});
  const [formState, setFormState] = useState({});

  const handleChange = (prop, e) => {
    formData[prop] = e.target.value;
    setFormData({ ...formData });
  };

  async function handleSubmit(e: any) {
    e.preventDefault();

    const { name, email, subject, message } = formData as any;

    if (!name || !email || !subject || !message) {
      setFormState({ ...formState, error: "Please fill in the required field." });
      return false;
    }
    
    const isSended = await sendEmailFunc({ name, email, subject, message });

    isSended ? 
      setFormState({ ...formState, error: "", success: "Your message was sent successfully. Thanks."  })
     : 
      setFormState({ ...formState, error: "There is some problem. Try after sometime!!" })
     
    // TODO: Validate

  }

  const sendEmailFunc = async (mailData: mailType) => {
    const { name, email, subject, message } = mailData;

    const emailHtml = await render(
      <MailTemplate
        name={name}
        email={email}
        subject={subject}
        message={message}
      />
    );

    const params = {
      Destination: {
        ToAddresses: ["media@redhatmedia.net"],
      },
      Message: {
        Body: {
          Html: {
            Charset: "UTF-8",
            Data: emailHtml,
          },
        },
        Subject: {
          Data: 'Gossipment - '+subject,
        },
      },
      Source: "info@gossipment.com",
    };

    try {
      const data = await ses.sendEmail(params);
      // console.log("Email sent:", data);
      return true;
    } catch (error) {
      // throw error;
      // console.error("Error sending email:", error);
      return false;
    }
  };

  return (
    <Layout>
      <Head>
        <title>{pageCont[0].seo.title}</title>
        <SEOMeta seoData={pageCont[0].seo} />
      </Head>

      <main className="single-content mt-5 mb-5">
        <div className="container">
          <div className="row gap-5">
            <div className="col-lg-12">
              <article className="main-content-wrapper">
                <section className="content-sec">
                  <h1>{pageCont[0].title}</h1>
                  <div
                    dangerouslySetInnerHTML={{ __html: pageCont[0].content }}
                  />
                  {/* <p>{JSON.stringify(formData)}</p> */}

                  <form
                    action=""
                    method="post"
                    className="contact-form"
                    onSubmit={handleSubmit}
                  >
                    <div className="formControl">
                      <input
                        onChange={(e) => handleChange("name", e)}
                        type="text"
                        placeholder="Name"
                        id="name"
                      />
                    </div>
                    <div className="formControl">
                      <input
                        onChange={(e) => handleChange("email", e)}
                        type="email"
                        placeholder="Email"
                        id="email"
                      />
                    </div>
                    <div className="formControl">
                      <input
                        onChange={(e) => handleChange("subject", e)}
                        type="text"
                        placeholder="Subject"
                        id="subject"
                      />
                    </div>
                    <div className="formControl">
                      <textarea
                        onChange={(e) => handleChange("message", e)}
                        cols={40}
                        rows={10}
                        placeholder="Message"
                        id="message"
                      ></textarea>
                    </div>
                    <input type="submit" value="Submit" className="btn" />
                  </form>

                  {formState["isLoading"] && <p>Please Wait...</p>}
                  {formState["state"] && <p>{formState["state"]}</p>}
                  {formState["error"] && <p className="text-error">{formState["error"]}</p>}
                  {formState["success"] && <p className="text-success">{formState["success"]}</p>}
                </section>
              </article>
            </div>
          </div>
        </div>
      </main>
    </Layout>
  );
}

export async function getStaticProps({ preview = false }) {
  const slug = "Contact Us";
  const pageData = await getInnerPageContent(slug, preview);

  const credentials = {
    region: process.env.SES_MAIL_REGION,
    accessKeyId: process.env.SES_MAIL_ACCESS_KEY,
    secretAccessKey: process.env.SES_MAIL_SECRET_KEY,
  };

  return {
    props: {
      preview,
      pageCont: pageData?.nodes ?? "",
      SES_credentials: credentials
    },
    revalidate: 60 * 60 * 24,
  };
}
